import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
let DndShipper = /** @class */ (() => {
    let DndShipper = class DndShipper extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "DnD Shipper";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Extras",
                    href: "#",
                },
                {
                    text: "DnD Shipper",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
        }
        mounted() {
            setTimeout(() => {
                this.pageIsLoading = false;
            }, 100);
        }
    };
    DndShipper = __decorate([
        Component({
            name: "DndShipper",
            components: {
                Layout,
                PageHeader,
                Loader,
            }
        })
    ], DndShipper);
    return DndShipper;
})();
export default DndShipper;
